// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Alert from 'react-s-alert';
import _ from 'lodash';
import $ from 'jquery';

import type {Element} from 'react';

import TreeUserItem from './TreeUserItem.jsx';
import LeftRight from './LeftRight.jsx';
import ButtonUp from './ButtonUp.jsx';
import App from './App.jsx';
import DialogUser from './DialogUser.jsx';

import get_order from './orden.js';
import {fetch_dir} from './fetch_things.js';
import {T_DIR} from './codtype.js';
import {mk_title, takeDir, takeFilename, abrev, no_rclick, path_is_inside, add_end_slash, scroll} from './utils.js';
import {ROOT_DIR} from './consts.js';

import type {T_Item, T_Node} from './types.js';

import './css/TreeUser.css';


type T_TreeUserProps = {
  name       : string,
  height     : number,
  app        : App,
  dialog_user: DialogUser,
  top_dirs   : Array<string>,          // carpetas de mayor nivel al que podemos acceder con go_up()
  black_dirs : Array<string>           // ¿hay algunas carpetas que no debamos mostrar?
};



type T_TreeUserStyle = {
  top : number,
  left: number
};



type T_TreeUserState = {
  ruta     : string,
  dirlist  : Array<T_Item>,
  style    : T_TreeUserStyle,
  maxHeight: number
};



export default class TreeUser extends Component<T_TreeUserProps, T_TreeUserState> {
  INIT_STATE  : T_TreeUserState;
  
  scroll_top  : () => void;
  go_up       : () => void;
  set_position: () => void;
  can_open    : (_dir: string) => boolean;
  
  
  constructor(props: T_TreeUserProps) {
    super(props);
    
    if (this.props.top_dirs.length === 0) {
      console.error('TreeUser: sin carpetas para escoger.');
    }
    
    this.INIT_STATE = {
      ruta   : (this.props.top_dirs.length === 1 ? this.props.top_dirs[0] : ''),
      dirlist: this.props.app.get_filelist(_.cloneDeep(this.props.top_dirs)),
      style  : {
        top : 100,
        left: 100
      },
      maxHeight: 100
    };
    
    this.state = _.cloneDeep(this.INIT_STATE);
    
    this.scroll_top   = this.scroll_top.bind(this);
    this.set_position = this.set_position.bind(this);
    this.go_up        = this.go_up.bind(this);
    this.can_open     = this.can_open.bind(this);
  }
  
  
  
  componentDidMount() {
    this.props.dialog_user.tree_user = this;
    
    this.set_position();
  }
  
  
  
  componentWillUnmount() {
    this.props.dialog_user.tree_user = null;
  }
  
  
  
  componentDidUpdate(prevProps: T_TreeUserProps, prevState: T_TreeUserState) {
    if (prevProps.height !== this.props.height) {
      this.set_position();
    }
  }
  
  
  
  set_position(): void {
    const ju = $(`.${this.props.dialog_user.cls_name}`);
    
    if (ju.length) {
      const pos = ju.position();
      
      this.setState({
        style: {
          top : pos.top,
          left: pos.left + ju.width() + 10
        },
        maxHeight: ju.height()
      });
    }
    else {
      _.delay(this.set_position, 100);
    }
  }
  
  
  
  scroll_top(): void {
    scroll(ReactDOM.findDOMNode(TreeUserItem.first));
  }
  
  
  
  open_dir(node: ?T_Item): void {
    if (node != null) {
      const ruta = node.Path;
      
      fetch_dir(this.props.app, ruta, (response) => {
        if (typeof response === 'string') {
          return Alert.error(response);
        }
        
        const xs = (response: Array<T_Node>);
        
        if (_.isArray(xs) && xs.filter(xx => xx.Type === 'dir').length === 0) {
          return;
        }
        
        this.setState({
          ruta,
          dirlist: _.sortBy(
            xs.filter(xn => ! this.props.app.is_black(xn.Path)).map(get_order).filter((xx) => {
              const fl = xx.File.toLowerCase();
              
              return xx.Type === 'dir' && (! fl.match(/^u_/)) && (! fl.match(/^x_/)) && xx.File !== 'lost+found';
            }
          ), xt => xt.File.toLowerCase())
        }, this.scroll_top);
      });
    }
    else {
      this.setState(_.pick(this.INIT_STATE, ['ruta', 'dirlist']));
    }
  }
  
  
  
  add_dir(node: T_Item): void {
    this.props.dialog_user.add_editing_dir(`${node.Path}/`);
  }
  
  
  
  can_open(_dir: string): boolean {
    const dir = add_end_slash(_dir);
    
    if (this.props.black_dirs.length > 0 && _.some(this.props.black_dirs, bdir => dir === bdir || path_is_inside(dir, bdir))) {
      return false;
    }
    
    if (_.some(this.props.top_dirs, tdir => dir.length < tdir.length && tdir.indexOf(dir) === 0)) {
      return false;
    }
    
    return true;
  }
  
  
  
  go_up(): void {
    const new_dir = takeDir(this.state.ruta);
    
    if ((new_dir === '/' || ! new_dir) && this.props.app.agrosat_user) {
      this.open_dir(null);
    }
    else if (this.can_open(new_dir)) {
      this.open_dir({
        Cod   : T_DIR,
        Path  : new_dir === '/' || ! new_dir ? ROOT_DIR : new_dir,
        File  : takeFilename(this.state.ruta),
        Type  : 'dir',
        label : '',
        order : 10,
        Loaded: false,
        Unpub : false,
        Days  : 0
      });
    }
  }
  
  
  
  ruta(): ?Element<*> {
    const dx   = _.last(this.state.ruta.slice(6).split('/')),
          raiz = dx === 'MAPS' || this.state.ruta === ROOT_DIR;
    
    if ((dx === '/' || (! dx)) && this.state.dirlist.length === 1) {
      return null;
    }
    
    const ruta = (
      <span className='tree_user_ruta'>
        {raiz || ! dx ? 'Carpeta raíz' : abrev(mk_title(dx), 20)}
      </span>  
    );
    
    return (
      <LeftRight
        left={
          <span>
            {ruta}
          </span>
        }
        right={
          <span>
            {this.bt_up(dx === 'MAPS')}
          </span>
        }
      />
    );
  }
  
  
  
  bt_up(on_root: boolean): Element<*> {
    return (
      <ButtonUp
        fun={this.go_up}
        enabled={! on_root}
      />
    );
  }
  
  
  
  render() {
    return (
      <div className='tree_user_panel' style={this.state.style} onContextMenu={no_rclick}>
        <div className='tree_user_header'>
          <p>
            Escoja las carpetas de <b>{this.props.name}</b>:
          </p>
          
          {this.ruta()}
        </div>
        
        <div className='tree_user_list' style={{maxHeight: this.state.maxHeight - 5}}>
          {this.state.dirlist.map((dir: T_Item, num: number) => {
            return (
              <TreeUserItem
                node={dir}
                key={num}
                num={num}
                tree_user={this}
              />
            );
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TreeUser.jsx